import dayjs from "dayjs"
import { VALIDATION_RULES } from "../../utils/constants"
import { ConOpsAnalysisSvg, CovarageAnalysisSvg, DeleteIcon, DeOrbitingAnalysisSvg, DeTumblingAnalysisSvg, DuplicateIcon, EditIcon, GPSAnalysisSvg, GroundLinkAnalysisSvg, GroundStationAnalysisSvg, GroupSvg, PropulsionAnalysisSvg, RenameIcon, SatelliteSvg, SensorAnalysisSvg, SettingIcon, TabSeparatorSvg, ThermalAnalysisSvg, TLEUploadIcon } from './Svgs';
import { AnalysisReportDataType, SensorConfig, TabTypes } from "./types"
import { uuidv4 } from "../../utils/commonFunctions";

export const MODELLING_DEFAULT_ORBIT_COLOR = '[67, 87, 196, 1]'

export const MODELLING_ORBIT_COLORS = [
    "[67, 87, 196, 1]",
    "[34, 121, 190, 1]",
    "[0, 142, 161, 1]",
    "[161, 136, 127, 1]",
    "[61, 153, 65, 1]",
    "[211, 223, 92, 1]",
    "[187, 168, 0, 1]",
    "[96, 125, 139, 1]",

    "[193, 149, 16, 1]",
    "[223, 139, 14, 1]",
    "[245, 122, 83, 1]",
    "[237, 44, 30, 1]",
    "[233, 30, 99, 1]",
    "[200, 70, 222, 1]",
    "[112, 59, 205, 1]",
    "[255, 235, 59, 1]",
];

export const SatelliteConfigButtons = [
    {
        label: 'SATELLITE',
        name: 'Satellite',
        Icon: <SatelliteSvg />,
    },
    {
        label: 'GROUP',
        name: 'Group',
        Icon: <GroupSvg />,
    },
    {
        label: 'TLE TRACK',
        name: 'Tle',
        Icon: <TLEUploadIcon />,
    }
]

export const SatelliteMenuList = [
    {
        name: 'Config',
        Icon: <SettingIcon />
    }
]
export const ReportMenuList = [
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
    {
        name: 'Rename',
        Icon: <RenameIcon />
    }
]
export const GroupSatMenuList = [
    {
        name: 'Edit',
        Icon: <EditIcon />
    },
    {
        name: 'Rename',
        Icon: <RenameIcon />
    },
    {
        name: 'Duplicate',
        Icon: <DuplicateIcon />
    },
    {
        name: 'Config',
        Icon: <SettingIcon />
    },
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
]

export const GroupContextMenuList = [
    {
        name: 'Show',
        Icon: <i className='fe fe-eye opacity-75' />
    },
    {
        name: 'Hide',
        Icon: <i className='fe fe-eye-off opacity-75' />
    },
    {
        name: 'Edit Config',
        Icon: <SettingIcon />
    },
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
]

export const MenuList = [
    {
        name: 'Rename',
        Icon: <RenameIcon />
    },
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
]

export const AnalysisTabList = [
    {
        name: 'Coverage',
        active: 'Coverage',
        Icon: <CovarageAnalysisSvg />,
        disabled: false
    },
    {
        name: 'Ground Contact',
        active: 'Contact',
        Icon: <GroundStationAnalysisSvg />,
        disabled: false
    },
    {
        name: 'Ground Link',
        active: 'GroundLink',
        Icon: <GroundLinkAnalysisSvg />,
        disabled: false
    },
    {
        name: '',
        active: '',
        Icon: <TabSeparatorSvg />,
        disabled: true
    },
    {
        name: 'Propulsion Budget',
        active: 'Propulsion',
        Icon: <PropulsionAnalysisSvg />,
        disabled: false
    },
    {
        name: 'De-Tumbling',
        active: 'De_Tumbling',
        Icon: <DeTumblingAnalysisSvg />,
        disabled: true
    },
    {
        name: 'De-Orbiting',
        active: 'De_Orbiting',
        Icon: <DeOrbitingAnalysisSvg />,
        disabled: true
    },
    {
        name: '',
        active: '',
        Icon: <TabSeparatorSvg />,
        disabled: true
    },
    {
        name: 'Thermal',
        active: 'Thermal',
        Icon: <ThermalAnalysisSvg />,
        disabled: true
    },
    {
        name: 'Sensor',
        active: 'Sensor',
        Icon: <SensorAnalysisSvg />,
        disabled: true
    },
    {
        name: 'GPS',
        active: 'GPS',
        Icon: <GPSAnalysisSvg />,
        disabled: true
    },
    {
        name: '',
        active: '',
        Icon: <TabSeparatorSvg />,
        disabled: true
    },
    {
        name: 'ConOps',
        active: 'ConOps',
        Icon: <ConOpsAnalysisSvg />,
        disabled: true
    },
]

export const ORBITOBJECTS = [
    {
        label: 'Altitude',
        name: 'altitude',
        placeholder: 'Enter Altitude (km)',
        range: [VALIDATION_RULES?.ORBITAL_ALTITUDE?.MIN, VALIDATION_RULES?.ORBITAL_ALTITUDE?.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_ALTITUDE.INPUT_LENGTH,
        parameter: 'km',
        unit: '(a)'
    }, {
        label: 'Eccentricity',
        name: 'eccentricity',
        placeholder: 'Enter Eccentricity (degree)',
        range: [VALIDATION_RULES.ORBITAL_ECCENTRICITY.MIN, VALIDATION_RULES.ORBITAL_ECCENTRICITY.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_ECCENTRICITY.INPUT_LENGTH,
        parameter: '',
        unit: '(e)'
    }, {
        label: 'Inclination',
        name: 'inclination',
        placeholder: 'Enter Inclination (degree)',
        range: [VALIDATION_RULES.ORBITAL_INCLINATION.MIN, VALIDATION_RULES.ORBITAL_INCLINATION.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_INCLINATION.INPUT_LENGTH,
        parameter: '°',
        unit: '(i)'
    }, {
        label: 'Argument of Perigee',
        name: 'AOP',
        placeholder: 'Enter Perigee (degree)',
        range: [VALIDATION_RULES.ORBITAL_AP.MIN, VALIDATION_RULES.ORBITAL_AP.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_AP.INPUT_LENGTH,
        parameter: '°',
        unit: '(ω)'
    }, {
        label: 'True Anomaly',
        name: 'TA',
        placeholder: 'Enter Anomaly (degree)',
        range: [VALIDATION_RULES.ORBITAL_TA.MIN, VALIDATION_RULES.ORBITAL_TA.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_TA.INPUT_LENGTH,
        parameter: '°',
        unit: '(ν)'
    }, {
        label: 'RAAN',
        name: 'RAAN',
        placeholder: 'Enter RAAN (degree)',
        range: [VALIDATION_RULES.ORBITAL_RAAN.MIN, VALIDATION_RULES.ORBITAL_RAAN.MAX],
        max_length: VALIDATION_RULES?.ORBITAL_RAAN.INPUT_LENGTH,
        parameter: '°',
        unit: '(Ω)'
    },
]

export const ORBIT_TYPE_OPTIONS = [{ label: "Custom", value: "Custom" }, { label: "SSO", value: "SSO" }, { label: "Polar", value: "Polar" }]
export const GROUP_TYPE_OPTIONS = [{ label: "Single Plane", value: "Single Plane" }, { label: "Multi Plane", value: "Multi Plane" }];
export const LIGHTING_CONDITION_OPTIONS = [{ label: "Both", value: "Both" }, { label: "Sunlit", value: "Sunlit" }, { label: "Eclipse", value: "Eclipse" }]


export const DEFAULT_SATELLITE_CONFIGURATION = {
    name: '',
    defaultNaming: true,
    orbitType: 'Custom',
    altitude: VALIDATION_RULES.ORBITAL_ALTITUDE.DEFAULT,
    semiMajorAxis: VALIDATION_RULES.ORBITAL_SEM.DEFAULT,
    eccentricity: VALIDATION_RULES.ORBITAL_ECCENTRICITY.DEFAULT,
    inclination: VALIDATION_RULES.ORBITAL_INCLINATION.DEFAULT,
    RAAN: VALIDATION_RULES.ORBITAL_RAAN.DEFAULT,
    AOP: VALIDATION_RULES.ORBITAL_AP.DEFAULT,
    TA: VALIDATION_RULES.ORBITAL_TA.DEFAULT,
    epoch: dayjs.utc().valueOf()
}
export const DEFAULT_GROUP_CONFIGURATION = {
    name: '',
    defaultNaming: true,
    orbitType: 'Custom',
    altitude: VALIDATION_RULES.ORBITAL_ALTITUDE.DEFAULT,
    semiMajorAxis: VALIDATION_RULES.ORBITAL_SEM.DEFAULT,
    eccentricity: VALIDATION_RULES.ORBITAL_ECCENTRICITY.DEFAULT,
    inclination: VALIDATION_RULES.ORBITAL_INCLINATION.DEFAULT,
    RAAN: VALIDATION_RULES.ORBITAL_RAAN.DEFAULT,
    AOP: VALIDATION_RULES.ORBITAL_AP.DEFAULT,
    TA: VALIDATION_RULES.ORBITAL_TA.DEFAULT,
    epoch: dayjs.utc().valueOf(),
    groupType: 'Single Plane',
    satelliteCount: 2,
    interAnglePhasingForSinglePlane: 180,
    isDefaultInterAnglePhasing: true,
}
export const DEFAULT_STATION_CONFIGURATION = {
    name: "",
    latitude: "",
    longitude: "",
    bands: [],
    status: "Configure",
    antennaId: [''],
    uniqueId: uuidv4()
}

export const DEFAULT_COVERAGEANALYSIS_DATA = {
    satellites: [],
    geoFeatures: [],
    startTime: dayjs.utc().valueOf(),
    duration: '',
    lightingCondition: 'Both',
    analysisType: 'Basic',
    sunAngle: '10',
    targetRevisitTime: '20',
    spotSpacing: '100',
    agility: 30
}
export const DEFAULT_GROUNDANALYSIS_DATA = {
    satellites: [],
    stations: [],
    startTime: dayjs.utc().valueOf(),
    duration: '',
}
export const DEFAULT_GROUNDLINKANALYSIS_DATA = {
    satellites: [],
    stations: [],
    geoFeatures: [],
    minContactTime: 3,
    optimalGroundStations: 5,
    lightingCondition: 'Sunlit',
    startTime: dayjs.utc().valueOf(),
    duration: 1,
}
export const DEFAULT_PROPULSION_DATA = {
    satellites: [],
    thrusters: [],
    missionLife: 1,
    stationKeepingTolerance: 0.7,
    wetMass: 120,
    geoMagneticIndex: 9,
    solarRadioFlux: 150,
    dragCoefficient: 2.2,
    effectiveSurfaceArea: 0.65
}

export const DEFAULT_THRUSTER_DATA = {
    thrusterId: '',
    name: 'Thruster_01',
    maxThrust: 5,
    specificImpulse: 950,
    totalImpulse: 1900,
    powerConsumption: 160
}


export const DEFAULT_ANALYSIS_REPORTS = {
    selectedTab: 'Coverage' as TabTypes,
    expanded: false,
    searching: false,
    latestreport: null,
    data: ['Coverage', 'Contact', 'GroundLink', 'Propulsion'].reduce((acc, tab) => ({
        ...acc,
        [tab]: {
            loading: tab === 'Coverage',
            reports: [],
            filterReports: [],
            selectedReport: null,
            searchValue: '',
            message: ''
        }
    }), {} as Record<TabTypes, AnalysisReportDataType>)
};

export const MAX_SATELLITE__COUNT = 1500;
export const MAP_CENTER = [0, 0];

export const MAP_DEFAULT_ZOOM = 2.03;
export const MAP_MIN_ZOOM = 2.02;

export const MAP_VIEWS = [
    {
        name: 'Falt Earth View',
        dimension: 'mercator',
    },
    {
        name: '3D Globe View',
        dimension: 'globe',
    },
];

export const MAP_STYLES = [
    {
        name: 'Mapbox Dark',
        style: 'dark-v10',
    },
    {
        name: 'Mapbox Satellite',
        style: 'satellite-v9'
    },
];

export const GEODATA_OPTIONS = [
    {
        name: 'Orders',
        type: 'orders',
    },
    {
        name: 'Leagacy Data',
        type: 'legacyData',
    },
]


export const GET_DEFAULT_DATA_BY_TYPE = (type: 'satellite' | 'group' | 'station' | 'coverage' | 'propulsion' | 'thruster' | 'ground_analysis' | 'ground_link_analysis') => {
    const currentTime = dayjs.utc().valueOf()
    switch (type) {
        case 'satellite':
            return {
                ...DEFAULT_SATELLITE_CONFIGURATION,
                epoch: currentTime
            }
        case 'group':
            return {
                ...DEFAULT_GROUP_CONFIGURATION,
                epoch: currentTime
            }
        case 'station':
            return DEFAULT_STATION_CONFIGURATION
        case 'coverage':
            return {
                ...DEFAULT_COVERAGEANALYSIS_DATA,
                startTime: currentTime
            }
        case 'propulsion':
            return DEFAULT_PROPULSION_DATA
        case 'thruster':
            return DEFAULT_THRUSTER_DATA
        case 'ground_analysis':
            return {
                ...DEFAULT_GROUNDANALYSIS_DATA,
                startTime: currentTime
            }
        case 'ground_link_analysis':
            return {
                ...DEFAULT_GROUNDLINKANALYSIS_DATA,
                startTime: currentTime
            }
        default:
            return null

    }
}

export const DEFAULT_SENSOR_CONFIG: SensorConfig = {
    sensor_type: 'conic',
    horizontal_fov: '',
    vertical_fov: '',
    horizontal_swath: '',
    vertical_swath: '',
    unit_selected: 'deg'
}